<template>
  <div id="panel-fiche" class="panel panel-default" role="container">
    <div
            class="panel-heading d-flex flex-column align-content-center"
    >
      <div class="d-flex justify-content-start" v-if="showEdit">
        <div v-if="typeof $route.params.idInvitation !== 'undefined'">
          <b-button
                  :to="`/invite/fiches-espaces/${this.currentProject()}/edit/${fiche.id}/${$route.params.idProject}/${$route.params.idInvitation}/${$route.params.tokenInvite}`"
                  variant="outline-primary"
                  class="edit-espace-btn"
          >
            <font-awesome-icon :icon="['fas', 'edit']" /> Editer
          </b-button>
        </div>
        <div v-else>
          <b-button
                  :to="`/fiches-espaces/${this.currentProject()}/edit/${fiche.id}`"
                  variant="outline-primary"
                  class="edit-espace-btn"
          >
            <font-awesome-icon :icon="['fas', 'edit']" /> Editer
          </b-button>
        </div>
        <b-button-group v-if="!pending">
          <b-dropdown
                  id="export"
                  class="txt-btn dropdown-btn font-type height-small remove-line-height"
                  variant="outline-primary"
          >
            <template v-slot:button-content>
              <font-awesome-icon :icon="['fas', 'upload']" /> Exporter
            </template>
            <b-dropdown-item
                    id="export-zip"
                    :style="[{ fontFamily: 'Arial', fontSize: '11px' }]"
                    @click="handleExportZip"
            >Export .zip</b-dropdown-item
            >
            <b-dropdown-item
                    @click="handleExportFusion"
                    :style="[{ fontFamily: 'Arial', fontSize: '11px' }]"
            >Export fusionné .pdf</b-dropdown-item
            >
          </b-dropdown>
        </b-button-group>
<!--        <b-button-->
<!--                @click="exporter()"-->
<!--                v-if="!pending"-->
<!--                variant="outline-primary"-->
<!--                class="edit-espace-btn mx-2"-->
<!--        >-->
<!--          <font-awesome-icon :icon="['fas', 'download']" /> Exporter-->
<!--        </b-button>-->
        <b-button v-else class="edit-espace-btn mx-2" variant="outline-primary">
          <b-spinner small type="grow"></b-spinner> En cours...
        </b-button>
      </div>
    </div>
    <div class="container-fiche">
      <div id="container-padding">
        <div class="wrapper-conteneur fiche-espaces">
          <conteneur :conteneurs="fiche.data.elements" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import conteneur from './display/conteneur'
import { defaultTitleStyle } from '../../config/constanteUse'
import htmlToImage from 'html-to-image'
import pdfMake from 'pdfmake/build/pdfmake'
import {eventBus} from '../../main'
import axios from 'axios'
import { ENTRYPOINT } from '../../config/entrypoint'
import html2canvas from 'html2canvas'
var JSZip = require('jszip')

export default {
  components: {
    conteneur
  },
  props: {
    fiche: {
      type: Object,
      required: true
    },
    modeVue: false
  },
  created () {
    eventBus.$on('getSelected', (message) => {
      this.getSelected = message
    })

    if (typeof this.fiche.isEditable !== 'undefined' && typeof this.fiche.isViewable !== 'undefined') {
      if (this.fiche.isEditable) {
        this.showEdit = true
      } else {
        this.showEdit = false
      }
    }
  },
  data () {
    return {
      defaultTitleStyle,
      pending: false,
      selectedFiche: null,
      getSelected: {},
      showEdit: true,
      titles: [],
      myBlob: []
    }
  },
  methods: {
    ...mapActions(['setMessage', 'generateFicheZIP', 'generateFicheFusion']),
    ...mapGetters(['currentProject', 'getFicheInfo']),
    // Zip all PDF .. may god save our soul on this one.
    async handleExportZip () {
      var data = this.$store.state.ficheEspace.selectedFiches;
      const res = await this.generateFicheZIP({data})
      this.displayToast(res);
    },
    async handleExportFusion () {
      var data = this.$store.state.ficheEspace.selectedFiches;
      const res = await this.generateFicheFusion({data})
      this.displayToast(res);
    },
    displayToast (success) {
      if (success) {
        this.setMessage('Export en cours, vous recevrez prochainement un mail avec vos fiches');
        return;
      }
      this.setMessage("Une erreur est survenue lors de l'export");
    },
    exporter () {
      this.pending = true
      htmlToImage.toPng(document.getElementById('container-padding'), {cacheBust: true}).then(dataUrl => {
        const base64data = dataUrl
        const docdefinition = {
          pageSize: 'A4',
          content: [
            {
              image: base64data,
              fit: [595, 842],
              margin: [-40, -30, 0, 0]
            }
          ]
        }
        pdfMake.createPdf(docdefinition).download(this.getFicheInfo().espaceData['H1'] + '.pdf' || 'Fiche.pdf')
        this.pending = false
      })
    }
  }
}
</script>

<style lang="scss">
  .remove-line-height > button{
    line-height: 23px;
    border-radius: 0;
    margin-left: 8px;
  }
  .container-fiche {
    border: 1px solid lightgrey;
    height: calc( 100% - 65px);
    overflow: auto;
  }
  .container-padding {
    background-color: #fff;
  }
  #panel-fiche {
    margin-top: 30px;
    h2 {
      font-size: 18px;
      font-weight: bold;
      text-transform: uppercase;
    }
    h3 {
      font-size: 16px;
      font-weight: bold;
    }
    .row-no-padding > [class*="col-"]:first-of-type {
      padding-right: 0;
    }
    .row-no-padding > [class*="col-"]:first-of-type {
      //border-right: 1px solid #d8e6f1;
    }
    .row-no-padding > [class*="col-"]:last-of-type {
      padding-left: 0;
      border: none;
    }
    font-family: "Open sans";
    .panel {
      border: none;
      box-shadow: none;
      border-radius: 0;
      margin-bottom: 15px;
    }
    &.panel[role="container"] {
      // border: 1px solid lightgray;
    }
    .wrapper-conteneur {
      height: calc( 100% );
      padding: 30px;
    }
    .panel-heading {
      padding: 0;
      border-radius: 0;
      border: none;
      background: #fff;
      border: none;
      text-transform: uppercase;
      height: 65px;
      .edit-espace-btn {
        border-radius: 0;
        height: 25px;
        line-height: 25px;
        color: #2b3085;
        border-color: #2b3085;
        &:hover {
          color: #fff;
        }
      }
    }

    .panel-heading[role="title"] {
      border-bottom: 2px solid #2b3085;
      padding: 30px 0;
    }

    .panel-heading[role="content"] {
      padding: 10px 0;
    }

    .panel-title {
      margin-bottom: 5px;
      display: block;
      text-align: center;
      color: #2369a3;
      position: relative;
      overflow: hidden;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/ficheEspaceContent.vue